import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import './scss/style.scss'
import { AppActions, AppSelectors } from './reducers/AppRedux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { PerformAuth } from './components/Auth'
import { AuthActions, AuthSelectors } from './reducers/AuthRedux'
import Loading from './components/Loading'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./components/Login'))

const RequireAuth = ({ children }) => {

  const isAuthenticated = useSelector(AuthSelectors.isAuthenticated)

  let location = useLocation()

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

const App = () => {
  const dispatch = useDispatch()

  const ready = useSelector(AppSelectors.isReady)

  useEffect(() => {
    dispatch(AppActions.startupRequest())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!ready) {
    return <Loading />
  }

  return (
    <HashRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/login" name="Login" element={<PerformAuth />} />
          <Route
            path="*"
            name="Home"
            element={
              <RequireAuth>
                <DefaultLayout />
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App

